import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Box from 'common/src/components/Box';
import Container from 'common/src/components/UI/Container';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import SliderDes from '../sliderDescription';
import Image1 from 'common/src/assets/image/app/t1.jpg';
import Image2 from 'common/src/assets/image/app/t2.jpg';
import Image3 from 'common/src/assets/image/app/t3.jpg';
import Image4 from 'common/src/assets/image/app/t4.png';
import Image5 from 'common/src/assets/image/app/t5.png';
import Image6 from 'common/src/assets/image/app/t6.jpg';

const TestimonialSection = ({ sectionWrapper }) => {
  const Data = useStaticQuery(graphql`
    query {
      appJson {
        testimonials {
          id
          name
          designation
          description
        }
      }
    }
  `);

  const images = [
    {
      thumbnail: `${Image1}`,
      thumbnailAlt: 'Sonia',
      description: <SliderDes data={Data.appJson.testimonials[0]} />,
    },
    {
      thumbnail: `${Image2}`,
      thumbnailAlt: 'Isabel',
      description: <SliderDes data={Data.appJson.testimonials[1]} />,
    },
    {
      thumbnail: `${Image3}`,
      thumbnailAlt: 'Antonio',
      description: <SliderDes data={Data.appJson.testimonials[2]} />,
    },
    {
      thumbnail: `${Image4}`,
      thumbnailAlt: 'Patricia',
      description: <SliderDes data={Data.appJson.testimonials[3]} />,
    },
    {
      thumbnail: `${Image5}`,
      thumbnailAlt: 'Carola',
      description: <SliderDes data={Data.appJson.testimonials[4]} />,
    },
    {
      thumbnail: `${Image6}`,
      thumbnailAlt: 'Soraya',
      description: <SliderDes data={Data.appJson.testimonials[5]} />,
    },
  ];

  return (
    <Box
      {...sectionWrapper}
      className="testimonialSlider"
      id="testimonialSection"
    >
      <Container>
        <Box className="testimonialDesWrapper">
          <ImageGallery
            items={images}
            originalClass="Testimonial-img"
            showPlayButton={false}
            showFullscreenButton={false}
          />
        </Box>
      </Container>
    </Box>
  );
};

TestimonialSection.propTypes = {
  sectionWrapper: PropTypes.object,
  title: PropTypes.object,
};

TestimonialSection.defaultProps = {
  sectionWrapper: {
    as: 'section',
    pt: '0px',
    pb: ['20px', '80px', '0px', '80px', '80px'],
  },

  sectionSubTitle: {
    content: 'TESTIMONIOS DE USUARIOS',
    as: 'span',
    display: 'block',
    textAlign: ['center', 'left'],
    fontSize: '14px',
    letterSpacing: '0.11em',
    fontWeight: '700',
    color: '#1a73e8',
    textTransform: 'uppercase',
    mb: '10px',
  },
};

export default TestimonialSection;
